"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));

const Flexible_1 = __importDefault(require("../flexible/Flexible"));
/**
 * This component can grow and shrink inside a FlexBox, Row or Column just like
 * a Flexible. Unlike a Flexible, however, this component also forces its child
 * to fill the available space.
 *
 * NB: This component is inspired by, but not identical to the Flutter
 * equivalent.
 * @see https://api.flutter.dev/flutter/widgets/Expanded-class.html
 */


const Expanded = styled_components_1.default(Flexible_1.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n\n  & > * {\n    width: 100%;\n    height: 100%;\n  }\n"])));
exports.default = Expanded;